import InputField from "../../../ReusableComponents/InputField"
import SelectField from "../../../ReusableComponents/SelectField"
import { AEROMEGH_SERVICES, PRICE_BY_TYPES, STATUS } from "../../../appConstants"
import { Button } from "../../../Components/Helper"
import { useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import Form from "../../../ReusableComponents/Form"
import Popup from "../../../ReusableFunctions/Popup"
import SelectLocation from "../../../features/MyLocations/SubComponents/SelectLocation"
import CustomToggle from "../../../ReusableComponents/CustomToggle"
import Modal from "../../../ReusableComponents/Modal"
import {
  DeleteRequestNoteValidation,
  modelNameValidation,
  selectFieldValidation,
} from "../../../utils/inputValidations"
import { acresToSquareKilometers, reduceLongName, squareKilometersToAcres } from "../../../ReusableFunctions/reusableFunctions"
import CreatableSelectField from "../../../ReusableComponents/CreatableSelectField"
import { v4 as uuid } from "uuid"
import Calender from "../../../assets/blueCalendar.svg"
import Loading from "../../../ReusableFunctions/Loader"
import { getAllDSPs } from "../../../apis/adminAPIs/dsp"
import { getDspLocations } from "../../../apis/BhuMeetTeams/CustomerSuccessEngineer/locations"
import { getSprayingRequestParameters } from "../../../apis/BhuMeetTeams/CustomerSuccessEngineer/request"
import { getApplicableCoupons } from "../../../apis/BhuMeetTeams/CustomerSuccessEngineer/coupons"
import { COUPON_TYPES } from "../../../appConstants"
import { EditExistingRequest } from "../../../apis/BhuMeetTeams/Oparations/requests"
import dateFormat from 'dateformat';
const EditRequestModal = ({ onClose, existingRequest }) => {
  function setNext15MinuteInterval() {
    const date = new Date() // Get the current date and time

    const minutes = date.getMinutes() // Get the current minutes
    const nextInterval = Math.ceil(minutes / 15) * 15 // Calculate the next 15-min interval

    // If the next interval is 60, move to the next hour
    if (nextInterval === 60) {
      date.setHours(date.getHours() + 1) // Increment the hour
      date.setMinutes(0) // Set minutes to 0 (start of next hour)
    } else {
      date.setMinutes(nextInterval) // Set the minutes to the next interval
    }

    date.setSeconds(0) // Reset seconds to 0
    date.setMilliseconds(0) // Reset milliseconds to 0

    return date
  }
  // Set the time to 11:00 AM
  const [request, setRequest] = useState({
    mobile_number: "",
    time: new Date(setNext15MinuteInterval()),
    field_lat: "",
    field_lng: "",
    field_name: { label: "", value: "" },
    field_address: "",
    field_area: null,
    applied_coupons: { label: "", value: "" },
    applied_dsp_coupons: { label: "", value: "" },
    price_by: false,
    dsp: { label: "", value: "" },
    crop: { label: "", value: "" },
    crop_stage: { label: "", value: "" },
    pesticides: { label: "", value: "" },
    location_id: { label: "", value: "" },
    service_amount: null,
    cgst: 0,
    sgst: 0,
    total_amount: null,
    name: "",
  })
  const [crops, setCrops] = useState([])
  const [minAcres, setMinAcres] = useState(1)
  const [cropStages, setCropStages] = useState([])
  const [locations, setLocations] = useState([])
  const [dsps, setDsps] = useState([])
  const [pesticides, setPesticides] = useState([])
  const [applicableCoupons, setApplicableCoupons] = useState([])
  const [couponLoading, setCouponLoading] = useState(false)
  const [mapLocation, setMapLocation] = useState()
  const [disableName, setDisableName] = useState(false)
  const [showDatePicker, setShowDatePicker] = useState(false)
  const [showTimePicker, setShowTimePicker] = useState(false)
  const [loading, setLoading] = useState(true)
  const [parametersLoading, setParametersLoading] = useState(false)
  const handleAddNewAgroChemical = (newOption) => {
    if (newOption) {
      const newAgro = {
        id: uuid(),
        chemical_name: newOption,
        subsidy: null,
      }
      setPesticides((prev) => [...prev, newAgro])
      setRequest((prev) => ({ ...prev, pesticides: { label: newAgro.chemical_name, value: newAgro.id } }))
    }
  }
  useEffect(() => {
    initData()
  }, [])

  useEffect(() => {
    if (request?.crop?.label && request.location_id?.value && request.dsp?.value && request?.field_area) {
      requestCalculation()
    } else {
      setRequest((prevRequest) => ({
        ...prevRequest,
        service_amount: 0,
        total_amount: 0,
        applied_dsp_coupon_total_amount: 0,
        applied_bhumeet_coupon_total_amount: 0,
      }))
    }
  }, [
    request.crop?.value,
    request.location_id?.value,
    request.dsp?.value,
    request?.field_area,
    request?.applied_coupons,
    request?.applied_dsp_coupons,
    request?.pesticides?.value,
  ])

  const initData = async () => {
    try {
      setLoading(true)
      const { dsps } = await getAllDSPs()
      let activeDsps=dsps.filter(d => d.dsp_is_active)
      setDsps(activeDsps)
      const selectedDsp = dsps.find((d) => d.dsp_id == existingRequest?.dsp_id)
      const parameters = await getSprayingRequestParameters({
        dspId: selectedDsp?.dsp_id,
        locationId: existingRequest?.location_id,
      })
      await getApplicableBhumeetCoupons(
        selectedDsp?.dsp_id,
        existingRequest?.location_id,
        existingRequest?.user?.id,
        existingRequest?.id,
      )

      const { crop_stages, pesticides, location_crops_cost_list, min_request_acreage } = parameters
      setCrops(() => location_crops_cost_list)
      setCropStages(() => crop_stages)
      const isPesticideExist = pesticides.some(p => p.chemical_name.toLowerCase() === existingRequest.pesticides?.toLowerCase())

      const pesticidesUpdated = pesticides

      if (!isPesticideExist && existingRequest.pesticides) {
        pesticidesUpdated.push({
          "id": uuid(),
          "chemical_name": existingRequest.pesticides,
          "subsidy": 0
        })
      }
      setPesticides(() => pesticidesUpdated)
      setMinAcres(() => Number(min_request_acreage))
      setRequest((prevData) => ({
        ...prevData,
        dsp: {
          label: selectedDsp?.dsp_name,
          value: selectedDsp?.dsp_id,
        },
        location_id: {
          label: existingRequest?.location_name,
          value: existingRequest?.location_id,
        },
        pesticides: {
          label: existingRequest?.pesticides,
          value: existingRequest?.pesticides,
        },
        crop: {
          label:existingRequest?.crops?.English || existingRequest?.crop_name,
          value:existingRequest?.crops?.English || existingRequest?.crop_name,
        },
        applied_coupons: {
          label: (existingRequest?.invoice?.applied_coupons?.find(c=> c.coupon_type === COUPON_TYPES.SYSTEM))?.coupon_code,
          value: (existingRequest?.invoice?.applied_coupons?.find(c=> c.coupon_type === COUPON_TYPES.SYSTEM))?.coupon_id,
        },
        applied_dsp_coupons: {
          label: (existingRequest?.invoice?.applied_coupons?.find(c=> c.coupon_type === COUPON_TYPES.DSP))?.coupon_code,
          value: (existingRequest?.invoice?.applied_coupons?.find(c=> c.coupon_type === COUPON_TYPES.DSP))?.coupon_id,
        },
        field_lat: existingRequest?.field_lat,
        field_lng: existingRequest?.field_lng,
        field_address: existingRequest?.field_address,
        field_name: existingRequest?.field_name,
        field_area: existingRequest?.price_by === "acre" ? squareKilometersToAcres(existingRequest?.field_area) : existingRequest?.field_area,
        price_by: existingRequest?.price_by === "acre" ? false : true,
        pesticide_per_acre_subsidy: pesticides.find((p) => p?.chemical_name === existingRequest?.pesticides)?.subsidy,
        service_amount_with_subsidy: existingRequest?.invoice?.service_amount_with_subsidy,
        mobile_number: existingRequest?.user?.mobile_number,
        time: new Date(existingRequest?.time),
      }))
      setLoading(false)
      Loading.set(false);
    } catch (e) {
      setLoading(false)
      Loading.set(false);
      console.log(e)
      Popup.alert("Something went wrong", e?.message, "ERROR")
    }
  }

  const requestCalculation = async () => {
    try {
      const crop_price_per_acre = crops.find((c) => c?.crop_name === request?.crop.label)?.cost
      const appliedCoupons = applicableCoupons.filter((c) => c.id === request.applied_coupons?.value || c.id === request.applied_dsp_coupons?.value)
      const {
        service_amount,
        total_amount,
        service_amount_with_subsidy,
        pesticides_subsidy,
        applied_dsp_coupon_total_amount,
        applied_bhumeet_coupon_total_amount,
      } = await getRequestCalculation(
        request?.field_area,
        request.price_by ? PRICE_BY_TYPES.TANK : PRICE_BY_TYPES.ACRE,
        request?.pesticide_per_acre_subsidy,
        crop_price_per_acre,
        appliedCoupons,
      )
      setRequest((prevRequest) => ({
        ...prevRequest,
        service_amount_with_subsidy,
        service_amount,
        total_amount,
        pesticides_subsidy,
        applied_dsp_coupon_total_amount,
        applied_bhumeet_coupon_total_amount,
      }))
    } catch (error) {
      console.error("Error in requestCalculation:", error)
      Popup.alert("Error", "Failed to calculate request amounts", "ERROR")
    }
  }

  const calculatePercentageTotal = (value, percentage) => Number((Number(value) * Number(percentage)) / 100)
  const getAppliedTotalAmountOfCoupon = (service_amount, coupon) => {
    if (coupon) {
      if (coupon.is_discount_in_percentage) {
        const totalAppliedAmountOfCouponViaPercentage = calculatePercentageTotal(
          service_amount,
          coupon.discount_percentage,
        )
        return Number(
          totalAppliedAmountOfCouponViaPercentage < Number(coupon.max_discount_value)
            ? totalAppliedAmountOfCouponViaPercentage
            : coupon.max_discount_value,
        )
      } else {
        return Number(coupon.discount_cost)
      }
    } else return 0
  }

  const getRequestCalculation = async (
    field_area,
    price_by,
    pesticide_per_acre_subsidy,
    crop_price_per_acre,
    appliedCoupons,
  ) => {
    try {
      field_area = Number(field_area)
      const cgst = 0
      const sgst = 0
      const service_amount = crop_price_per_acre * field_area
      const pesticides_subsidy = pesticide_per_acre_subsidy * Number(field_area)

      const service_amount_with_subsidy = service_amount - pesticides_subsidy
      if (appliedCoupons.length > 2)
        throw {
          errorMessage: "Bad request, You can only apply 2 coupons.",
          status: 400,
        }
      //////
      let dspCoupons = []
      let bhumeetCoupons = []

      bhumeetCoupons = appliedCoupons.filter((ac) => ac.coupon_type === COUPON_TYPES.SYSTEM)
      dspCoupons = appliedCoupons.filter((ac) => ac.coupon_type === COUPON_TYPES.DSP)
      if (bhumeetCoupons.length > 1 || dspCoupons.length > 1)
        throw {
          errorMessage: "Bad request, You can only apply 1 of dsp and 1 of bhumeet coupon.",
          status: 400,
        }
      ///////
      const applied_dsp_coupon_total_amount = getAppliedTotalAmountOfCoupon(service_amount_with_subsidy, dspCoupons[0])
      const applied_bhumeet_coupon_total_amount = getAppliedTotalAmountOfCoupon(
        service_amount_with_subsidy,
        bhumeetCoupons[0],
      )
      const total_discounted_amount_via_coupons = applied_bhumeet_coupon_total_amount + applied_dsp_coupon_total_amount
      const total_dsp_discount_percentage = 0
      const total_discounted_amount_via_dsp = calculatePercentageTotal(
        service_amount_with_subsidy,
        total_dsp_discount_percentage,
      )
      const service_amount_with_applied_discount_and_coupons =
        service_amount_with_subsidy - total_discounted_amount_via_coupons - total_discounted_amount_via_dsp
      const applied_csgt_amount = calculatePercentageTotal(service_amount_with_applied_discount_and_coupons, cgst)
      const applied_sgst_amount = calculatePercentageTotal(service_amount_with_applied_discount_and_coupons, sgst)
      const total_amount_with_applied_coupons_and_gst_and_discounts =
        service_amount_with_applied_discount_and_coupons + applied_csgt_amount + applied_sgst_amount
      const total_amount_without_bhumeet_coupon =
        total_amount_with_applied_coupons_and_gst_and_discounts + applied_bhumeet_coupon_total_amount
      return {
        service_amount,
        pesticides_subsidy,
        service_amount_with_subsidy,
        total_discounted_amount_via_coupons,
        total_discounted_amount_via_dsp,
        service_amount_with_applied_discount_and_coupons,
        applied_csgt_amount,
        applied_sgst_amount,
        total_amount: Number(total_amount_with_applied_coupons_and_gst_and_discounts.toFixed(2)),
        cgst,
        sgst,
        total_amount_without_bhumeet_coupon,
        applied_dsp_coupon_total_amount,
        applied_bhumeet_coupon_total_amount,
        pesticide_per_acre_subsidy,
      }
    } catch (e) {
      throw e
    }
  }

  const handleCreateRequest = async (updatedReq) => {
    Loading.set(true)
    try {
      const finalReq = { ...request }
      finalReq.price_by = updatedReq.price_by == true ? PRICE_BY_TYPES.TANK : PRICE_BY_TYPES.ACRE
      finalReq.crop_name = updatedReq?.crop?.label
      //add field addres, name ,lat lng etc
      finalReq.location_id = updatedReq?.location_id?.value
      finalReq.mobile_number = updatedReq?.mobile_number
      finalReq.time = new Date(updatedReq.time).toISOString() //check this
      //calculate service and total amount
      finalReq.cgst = updatedReq.cgst
      finalReq.sgst = updatedReq.sgst

      // CALCULATIONS
      const field_area = Number(finalReq.field_area)

      finalReq.pesticides = updatedReq?.pesticides?.label
      finalReq.service_amount = updatedReq?.service_amount
      finalReq.total_amount = updatedReq?.total_amount
      finalReq.field_name = updatedReq?.field_name
      finalReq.field_address = updatedReq.field_address
      finalReq.field_lat = updatedReq.field_lat
      finalReq.field_lng = updatedReq.field_lng
      finalReq.request_type = AEROMEGH_SERVICES.SPRAYING
      finalReq.field_area = finalReq.price_by == PRICE_BY_TYPES.ACRE ? acresToSquareKilometers(field_area) : field_area
      finalReq.mobile_number = existingRequest?.user?.mobile_number
      finalReq.customer_name = existingRequest?.user?.name
      finalReq.dsp_id = updatedReq.dsp?.value
      finalReq.applied_coupons = []
      if (updatedReq.applied_coupons?.value && updatedReq.applied_coupons?.value!=="None") {
        finalReq.applied_coupons.push(updatedReq.applied_coupons?.value)
      }
      if (updatedReq.applied_dsp_coupons?.value && updatedReq.applied_dsp_coupons?.value!=="None") {
        finalReq.applied_coupons.push(updatedReq.applied_dsp_coupons?.value)
      }
      await EditExistingRequest({
        note: updatedReq?.note,
        existingRequestId: existingRequest?.id,
        request: finalReq,
      })
      Popup.alert("SUCCESS", "Request updated successfully", "SUCCESS", onClose)
      Loading.set(false)
    } catch (err) {
      Loading.set(false)
      console.log(err)
      Popup.alert("ERROR", err || "Something went wrong while updating request", "ERROR")
    }
  }
  const getApplicableBhumeetCoupons = async (dsp_id, location_id, user_id, request_id) => {
    try {
      setCouponLoading(true)
      const coupons = await getApplicableCoupons(
        user_id,
        location_id,
        dsp_id,
        existingRequest ? existingRequest.id : request_id,
      )
      setApplicableCoupons(() => coupons)
      const appliedBhumeetCoupon = existingRequest?.invoice?.applied_coupons?.find(ac => ac.coupon_type === COUPON_TYPES.SYSTEM)
      const appliedDspCoupon = existingRequest?.invoice?.applied_coupons?.find(ac => ac.coupon_type === COUPON_TYPES.DSP)
      setRequest({ 
        ...request, 
        applied_coupons: coupons.some(c => c.coupon_type === COUPON_TYPES.SYSTEM && c.id === appliedBhumeetCoupon?.coupon_id) ? { label: appliedBhumeetCoupon.coupon_code, value: appliedBhumeetCoupon.coupon_id } : null, 
        applied_dsp_coupons : coupons.some(c => c.coupon_type === COUPON_TYPES.DSP && c.id === appliedDspCoupon?.coupon_id) ? { label: appliedDspCoupon.coupon_code, value: appliedDspCoupon.coupon_id } : null
      })
      setCouponLoading(false)
    } catch (err) {
      setCouponLoading(false)
      Popup.alert("Error", err, "ERROR")
    }
  }

  useEffect(() => {
    initData()
  }, [])

  useEffect(() => {
    getApplicableBhumeetCoupons(request?.dsp?.value, request?.location_id?.value, existingRequest?.user?.id, existingRequest?.id)
  }, [request?.location_id?.value, request?.dsp?.value])

  let  dspIsActive=dsps?.filter((d)=>d.dsp_is_active).some((dsp)=>dsp.dsp_id===request.dsp?.value);
  return (
    <Modal
      header={"Update Request"}
      open={true}
      headerContainerStyle={{ padding: "20px 30px" }}
      onClose={onClose}
      closeOnDocumentClick={false}
      contentStyle={{
        height: "700px",
        width: "1200px",
        boxShadow: " 0px 1px 4px 3px #76767626",
        border: "1px solid #BFC8D9",
        borderRadius: "8px",
        position: "relative",
      }}
    >
      <div style={{ display: "flex", width: "100%", height: "100%" }}>
        <div style={{ width: "800px" }}>
          <SelectLocation
            existingLocation={{
              lat: request.field_lat,
              lng: request.field_lng,
              address: request.field_address,
            }}
            disabledSearch={true}
            onLocationChange={(location) => {
              setMapLocation(location)
            }}
          />
        </div>
        <Form
          onSubmitForm={(req) => {
            handleCreateRequest(req)
          }}
          initialValues={request}
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "calc(100% - 65px)",
            padding: "20px 30px",
            gap: "20px",
            maxHeight: "calc(100% - 65px)",
            overflow: "auto",
          }}
        >
          {(onSubmit, formValue) => (
            <>
              <div style={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between", width: "100%", overflow: "auto" }}>
                <div
                  id="coupen-form"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridAutoRows: "auto",
                    gap: "3px 30px",
                    maxHeight: "calc(100% - 200px)",
                  }}
                >
                  <SelectField
                    isLoading={loading}
                    isDisabled={false}
                    label={"DSP"}
                    info={reduceLongName(dsps?.find((d) => d.dsp_id == existingRequest?.dsp_id)?.dsp_name, 20)}
                    isSearchable={true}
                    placeholderText={"selecte DSP"}
                    name="dsp"
                    styles={{ width: "215px", height: "18px", fontSize: "13px" }}
                    list={dsps.map((d) => ({ label: d.dsp_name, value: d.dsp_id }))}
                    containerStyle={{
                      width: "100%",
                      maxWidth: "100%",
                      minHeight: "75px",
                    }}
                    menuPortalTarget={document.getElementById("modalHolder")}
                    controlStyle={{ height: "auto" }}
                    handleChange={async (dsp) => {
                      setParametersLoading(true)
                      setRequest((prev) => ({
                        ...prev,
                        dsp: dsp,
                        crop: null,
                        pesticides : null,
                        location_id: null,
                        applied_coupons: [],
                        applied_dsp_coupons : []
                      }))
                      setCrops([])
                      setPesticides([])
                      setApplicableCoupons([])
                      const locations = await getDspLocations({ dspId: dsp?.value, only_active_locations: true })
                      setLocations(locations)
                      setParametersLoading(false)
                    }}
                    validation={selectFieldValidation}
                  />

                  <SelectField
                    isLoading={parametersLoading}
                    isDisabled={false}
                    label={"Location"}
                    info={reduceLongName(existingRequest?.location_name, 15)}
                    isSearchable={true}
                    placeholderText={"Select Location"}
                    name="location_id"
                    styles={{ width: "215px", height: "18px", fontSize: "13px" }}
                    list={locations.filter((l)=>l.is_active).map((l) => ({ label: l.name, value: l.id }))}
                    containerStyle={{
                      width: "100%",
                      maxWidth: "100%",
                      minHeight: "75px",
                    }}
                    menuPortalTarget={document.getElementById("modalHolder")}
                    controlStyle={{ height: "auto" }}
                    handleChange={async (location) => {
                      setParametersLoading(true)
                      setRequest((prev) => ({
                        ...prev,
                        location_id: location,
                        crop: null,
                        applied_coupons: [],
                        applied_dsp_coupons : []
                      }))
                      setApplicableCoupons([])
                      const parameters = await getSprayingRequestParameters({
                        dspId: request?.dsp?.value,
                        locationId: location?.value,
                      })
                      
                      const { crop_stages, pesticides, location_crops_cost_list, min_request_acreage } = parameters
                      setCrops(() => location_crops_cost_list)
                      setMinAcres(() => Number(min_request_acreage))
                      setCropStages(crop_stages)
                      const isPesticideExist = pesticides.some(p => p.chemical_name.toLowerCase() === existingRequest.pesticides?.toLowerCase())

                      const pesticidesUpdated = pesticides

                      if (!isPesticideExist && existingRequest.pesticides) {
                        pesticidesUpdated.push({
                          "id": uuid(),
                          "chemical_name": existingRequest.pesticides,
                          "subsidy": 0
                        })
                      }
                      setPesticides(pesticidesUpdated)
                      setParametersLoading(false)
                    }}
                    validation={selectFieldValidation}
                  />

                  <div style={{ display: "flex", width: "100%", gap: "10px", alignItems: "start" }}>
                    <div className="input_field" style={{ gap: "5px", width: "100%" }}>
                      <div className="flex font-[13px] gap-2 items-center text-[#3B3B3B]">
                        <label htmlFor="expiryDate" >
                          {"Date"}
                        </label>
                        <span style={{ fontSize: "13px", }}>{`(${dateFormat(existingRequest?.time, "dd/mm/yyyy")})`}</span>
                      </div>
                      <div
                        className="input-date"
                        style={{
                          position: "relative",
                          display: "flex",
                          flexDirection: "column",
                          rowGap: "5px",
                          justifyContent: "center",
                          width: "100%",
                          height: "35px",
                          border: "1.4px solid rgba(217, 217, 217, 0.84)",
                        }}
                        onClick={() => setShowDatePicker(true)}
                      >
                        <DatePicker
                        dateFormat="dd/MM/yyyy" 
                          readOnly
                          minDate={new Date()}
                          onClickOutside={() => setShowDatePicker(false)}
                          open={showDatePicker}
                          value={new Date(request.time)}
                          selected={new Date(request.time)}
                          className="input-date-hidden"
                          containerStyle={{ width: "100%" }}
                          onChange={(date, e) => {
                            e.stopPropagation()
                            const selectedDate = new Date(date)
                            setRequest((prev) => {
                              const updatedTime = prev.time ? new Date(prev.time) : new Date() // Get current time if not selected
                              // Merge the selected date with the stored time
                              const updatedDateTime = new Date(
                                selectedDate.setHours(updatedTime.getHours(), updatedTime.getMinutes()),
                              )
                              return { ...prev, time: new Date(updatedDateTime) }
                            })
                            setShowDatePicker(false)
                          }}
                        />
                        <img
                          src={Calender || "/placeholder.svg"}
                          alt="Calender"
                          style={{ width: "18px", position: "absolute", right: "15px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <CreatableSelectField
                    isLoading={parametersLoading}
                    onCreateOption={handleAddNewAgroChemical}
                    isSearchable={true}
                    info={reduceLongName(existingRequest?.pesticides, 15)}
                    isDisabled={false}
                    placeholder={"Select AgroChemical"}
                    label={"Agrochemical"}
                    name={"pesticides"}
                    styles={{ width: "215px", height: "18px", fontSize: "13px" }}
                    list={pesticides.map((l) => ({ label: l.chemical_name, value: l.id }))}
                    containerStyle={{
                      width: "100%",
                      maxWidth: "100%",
                      minHeight: "75px",
                    }}
                    menuPortalTarget={document.getElementById("modalHolder")}
                    controlStyle={{ height: "auto" }}
                    handleChange={(value) => {
                      const pesticide_per_acre_subsidy = pesticides.find(
                        (p) => p.chemical_name === value.label,
                      )?.subsidy
                      setRequest((prev) => ({ ...prev, pesticides: value, pesticide_per_acre_subsidy }))
                    }}
                    validation={modelNameValidation}
                  />

                  <SelectField
                    isLoading={loading || parametersLoading}
                    isDisabled={request?.location_id?.value && request?.dsp?.value ? false : true}
                    isSearchable={true}
                    label={"Crop"}
                    info={reduceLongName(existingRequest.crops?.English || existingRequest?.crop_name, 15)}
                    placeholderText={"Select Crop"}
                    name="crop"
                    styles={{ width: "215px", height: "18px", fontSize: "13px" }}
                    list={crops.map((l) => ({ label: l.crop_name, value: l.crop_id }))}
                    containerStyle={{
                      width: "100%",
                      maxWidth: "100%",
                      minHeight: "75px",
                    }}
                    menuPortalTarget={document.getElementById("modalHolder")}
                    controlStyle={{ height: "auto" }}
                    handleChange={async (value) => {
                      setRequest((prev) => ({ ...prev, crop: value, applied_coupons : null, applied_dsp_coupons : null }))
                    }}
                    validation={selectFieldValidation}
                  />
                    {request.price_by ? (
                    <InputField
                      handleChange={(value) => {
                        setRequest((prev) => ({ ...prev, field_area: value }))
                      }}
                      disabled={false}
                      info={existingRequest.price_by === "acre" ? squareKilometersToAcres(existingRequest?.field_area) : existingRequest?.field_area}
                      label={"No. of Tanks"}
                      placeholder={"Enter no. of tanks"}
                      name={"field_area"}
                      validation={{
                        required: "Required",
                        maxLength: {
                          value: 3,
                          message: "Max allowed number is 999.",
                        },
                        validate: (value) => {
                          if (isNaN(value)) {
                            return "Must be a number."
                          } else if (value <= 0 || value > 999) {
                            return "No. of tanks should be between 1 to 999"
                          } else if (value < minAcres) {
                            return `Minimum required tanks is ${minAcres}`
                          }
                        },
                        format: {
                          value: /^[0-9]+$/,
                          message: "Must be a number.",
                        },
                      }}
                      type={"number"}
                    />
                  ) : (
                    <InputField
                      handleChange={(value) => {
                        setRequest((prev) => ({ ...prev, field_area: value, applied_coupons : null, applied_dsp_coupons : null }))
                      }}
                      disabled={false}
                      label={"Area (Acre)"}
                      info={existingRequest.price_by === "acre" ? squareKilometersToAcres(existingRequest?.field_area) : existingRequest?.field_area}
                      placeholder={"Enter field area "}
                      name={"field_area"}
                      validation={{
                        required: "Required",
                        maxLength: {
                          value: 3,
                          message: "Max allowed number is 999.",
                        },
                        validate: (value) => {
                          if (isNaN(value)) {
                            return "Must be a number."
                          } else if (value <= 0 || value > 999) {
                            return "No. of tanks should be between 1 to 999"
                          } else if (value < minAcres) {
                            return `Minimum required area is ${minAcres}`
                          }
                        },
                        format: {
                          value: /^[0-9]+$/,
                          message: "Must be a number.",
                        },
                      }}
                      type={"number"}
                    />
                  )}

                  <SelectField
                    isLoading={loading || couponLoading}
                    isDisabled={request?.location_id?.value && request?.dsp?.value ? false : true}
                    isSearchable={true}
                    label={"BhuMeet Coupons"}
                    placeholderText={"Select BhuMeet Coupons"}
                    name="applied_coupons"
                    info={(existingRequest?.invoice?.applied_coupons?.find(c=> c.coupon_type === COUPON_TYPES.SYSTEM))?.coupon_code}
                    styles={{ width: "215px", height: "18px", fontSize: "13px" }}
                    list={
                     [{label:"None",value:"None"}, ...applicableCoupons.filter(c => c.coupon_type === COUPON_TYPES.SYSTEM && Number(c.min_order_value) <= Number(request.service_amount_with_subsidy))
                      .map((l) => ({ label: l.coupon_code, value: l.id }))]
                    }
                    containerStyle={{
                      width: "100%",
                      maxWidth: "100%",
                      minHeight: "75px",
                    }}
                    menuPortalTarget={document.getElementById("modalHolder")}
                    controlStyle={{ height: "auto" }}
                    handleChange={async (value) => {
                      setRequest((prev) => ({ ...prev, applied_coupons: value }))
                    }}
                  />

                  <SelectField
                    isLoading={loading || couponLoading}
                    isDisabled={request?.location_id?.value && request?.dsp?.value ? false : true}
                    isSearchable={true}
                    label={"DSP Coupons"}
                    placeholderText={"Select DSP Coupon"}
                    name="applied_dsp_coupons"
                    info={(existingRequest?.invoice?.applied_coupons?.find(c=> c.coupon_type === COUPON_TYPES.DSP))?.coupon_code}
                    styles={{ width: "215px", height: "18px", fontSize: "13px" }}
                    list={[{label:"None",value:"None"},...applicableCoupons.filter(c => c.coupon_type === COUPON_TYPES.DSP && Number(c.min_order_value) <= Number(request.service_amount_with_subsidy))
                      .map((l) => ({ label: l.coupon_code, value: l.id }))]}
                    containerStyle={{
                      width: "100%",
                      maxWidth: "100%",
                      minHeight: "75px",
                    }}
                    menuPortalTarget={document.getElementById("modalHolder")}
                    controlStyle={{ height: "auto" }}
                    handleChange={async (value) => {
                      setRequest((prev) => ({ ...prev, applied_dsp_coupons: value }))
                    }}
                  />

                  {/* <div style={{ display: "flex", flexDirection: "column", width: "100%", }}>
                    {existingRequest.price_by && <span style={{ fontSize: "13px" }}>({existingRequest?.price_by})</span>}
                    <CustomToggle
                      onText={"Tank"}
                      offText={"Acre"}
                      name={"price_by"}
                      handleChange={(value) => {
                        setRequest((prev) => ({ ...prev, price_by: value, field_area: null })) //this is required real time to change inputs of acre and tank
                      }}
                      defaultValue={request.price_by}
                    />
                  </div> */}

                  {dsps.find((d) => d.dsp_id == existingRequest?.dsp_id)?.dsp_name !== request?.dsp?.label && (
                    <InputField
                      handleChange={(value) => {
                        setRequest((prev) => ({ ...prev, note: value }))
                      }}
                      disabled={false}
                      label={"Note"}
                      placeholder={"Why you are changing DSP ?"}
                      name={"note"}
                      validation={DeleteRequestNoteValidation}
                      type={"text"}
                    />
                  )}
                </div>
                {/* payment Summary  */}
                <div>
                  {
                    <div
                      style={{
                        padding: "0 20px",
                        border: "1px solid #BFC8D9",
                        borderRadius: "7px",
                        visibility: request.service_amount > 0 ? "visible" : "hidden",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "10px 0",
                          fontSize: "15px",
                          fontWeight: "500",
                        }}
                      >
                        Payment Summary
                      </div>
                      <div
                        style={{
                          borderBottom: "1px solid #BFC8D9",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <div>
                            <span style={{ fontSize: "13px", color: "#3B3B3B", marginRight: "5px" }}>
                              Service Charges
                            </span>
                            {/* <span style={{ fontSize: "12px", color: "#848484" }}>{`(${paymentSummaryCalculations.field_area} ${(paymentSummaryCalculations?.price_by == PRICE_BY_TYPES.ACRE || !paymentSummaryCalculations?.price_by) ? "Acres" : "Tanks"} x ${(paymentSummaryCalculations.service_amount_per_acre).toFixed(2)} Rs. per ${(paymentSummaryCalculations?.price_by == PRICE_BY_TYPES.ACRE || !paymentSummaryCalculations?.price_by) ? "Acre" : "Tank"})`}</span> */}
                          </div>
                          <div style={{ fontSize: "13px", color: "#3B3B3B" }}>
                            ₹ {request.service_amount ? request.service_amount.toFixed(2) : "00"}
                          </div>
                        </div>
                        {Number(request.pesticides_subsidy) != 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontSize: "13px", color: "#3B3B3B" }}>Subsidy</div>
                            <div style={{ fontSize: "13px", color: "#32B338" }}>
                              -₹ {request.pesticides_subsidy ? request.pesticides_subsidy.toFixed(2) : "00"}
                            </div>
                          </div>
                        )}
                        {Number(request.applied_dsp_coupon_total_amount) != 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontSize: "13px", color: "#3B3B3B" }}>DSP Coupon</div>
                            <div style={{ fontSize: "13px", color: "#32B338" }}>
                              -₹{" "}
                              {request.applied_dsp_coupon_total_amount
                                ? request.applied_dsp_coupon_total_amount.toFixed(2)
                                : "00"}
                            </div>
                          </div>
                        )}
                        {Number(request.applied_bhumeet_coupon_total_amount) != 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontSize: "13px", color: "#3B3B3B" }}>Bhumeet Coupon</div>
                            <div style={{ fontSize: "13px", color: "#32B338" }}>
                              -₹{" "}
                              {request.applied_bhumeet_coupon_total_amount
                                ? request.applied_bhumeet_coupon_total_amount.toFixed(2)
                                : "00"}
                            </div>
                          </div>
                        )}

                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "10px 0",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        <div>
                          {request.status == STATUS.PAID || request.status == STATUS.COMPLETED
                            ? "Total Amount"
                            : "Estimated Amount"}
                        </div>
                        <div> ₹ {request.total_amount ? request.total_amount.toFixed(2) : "00"}</div>
                      </div>
                    </div>
                  }
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row-reverse",
                    padding: "10px 0px 15px",
                    gap: "20px",
                    marginTop: "auto",
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "white",
                  }}
                >
                  <Button
                    text={"Update"}
                    className={"btn-large"}
                    type={"Save"}
                    onClick={onSubmit}
                    isDisabled={
                       !dspIsActive ||
                      !request?.field_address ||
                      !request.field_lat ||
                      !request?.field_lng ||
                      !request.location_id?.value ||
                      !request.crop?.value ||
                      !request.pesticides?.value
                    }
                  />
                  <Button
                    text={"Cancel"}
                    type={"button"}
                    onClick={onClose}
                    isBtnNotActive={true}
                    className={"btn-large "}
                  />
                </div>
              </div>
            </>
          )}
        </Form>
      </div>
    </Modal>
  )
}
export default EditRequestModal

